import axios from "axios";

const API = axios.create({
  //baseURL: "http://localhost:5000/api",
  // For production:
  baseURL: "https://loan-app-backend-g2fe.onrender.com/api",

  headers: {
    "Content-Type": "application/json",
  },
});

/* ===============================
   REQUEST INTERCEPTOR
   =============================== */
API.interceptors.request.use(
  (config) => {
    const token =
      localStorage.getItem("token") ||
      JSON.parse(localStorage.getItem("user") || "{}")?.token;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/* ===============================
   RESPONSE INTERCEPTOR
   =============================== */
API.interceptors.response.use(
  (response) => response,

  (error) => {
    // 🌐 Network / Server down
    if (!error.response) {
      alert(
        "Network error. Please check your internet connection | Restart your Server"
      );
      return Promise.reject(error);
    }

    // 🔐 Unauthorized → Auto Logout
    if (error.response.status === 401) {
      localStorage.clear();

      setTimeout(() => {
        window.location.href = "/login";
      }, 1500);
    }

    // ❗ Server errors (500 etc)
    if (error.response.status >= 500) {
      console.error("Server error:", error.response.data);
    }

    return Promise.reject(error);
  }
);

export default API;
